import { createFileRoute } from '@tanstack/react-router';
import { ItensCifPage, lerBuscaItensCif } from '@/components/itens-cif';

export const Route = createFileRoute('/_app/custos/itens-cif')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaItensCif(bruto),
  component: ItensCifRota,
});

function ItensCifRota() {
  return <ItensCifPage aba={Route.useSearch().aba} />;
}
